import {Link} from '@/i18n/routing';
import {useTranslations} from 'next-intl';
import Image from 'next/image';
import {BarStoreRecord} from '../utils';

interface Props {
  store: BarStoreRecord;
  isSelected: boolean;
  onClick: (item: BarStoreRecord) => void;
}

export default function StoreItem({store, isSelected, onClick}: Props) {
  const t = useTranslations('bar');

  const onItemClick = (event) => {
    if (event.target.localName === 'a') {
      return;
    }
    onClick(store);
  };

  return (
    <li
      key={store.id}
      className={
        !isSelected
          ? 'transition-colors duration-300 flex flex-col md:flex-row border rounded-md lg:cursor-pointer md:min-h-44 hover:bg-gray-100'
          : 'transition-colors duration-300 flex flex-col md:flex-row border rounded-md lg:cursor-pointer md:min-h-44 lg:border-secondary-light lg:bg-greyscale-pink'
      }
      onClick={(event) => onItemClick(event)}
    >
      <div className="min-h-44 md:h-full md:w-44 rounded-t-md md:rounded-tr-none md:rounded-l-md overflow-hidden">
        <Image
          width={200}
          height={200}
          src={store.image}
          alt={store.name}
          className="h-full w-full object-cover"
        />
      </div>

      <div className="mx-3 my-4 flex-1 flex flex-col gap-3 justify-between">
        <div>
          <h3 className="mb-2 text-lg sm:text-xl font-semibold tracking-tight text-greyscale-title">
            {store.name}
          </h3>

          <div className="font-medium text-greyscale-body">
            <Link
              className="text-sm text-primary hover:text-primary underline hover:no-underline"
              rel="nofollow"
              target="_blank"
              // @ts-expect-error
              href={
                store.mapsData
                  ? `https://www.google.com/maps/search/?api=1&query=${store.mapsData.name}&query_place_id=${store.mapsData.placeId}`
                  : `https://www.google.com/maps/search/?api=1&query=${store.position.latitude}%2C${store.position.longitude}`
              }
            >
              {store.address}
            </Link>
          </div>
          <div
            className="font-medium mr-1 text-greyscale-body text-sm"
            style={{whiteSpace: 'pre-line'}}
          >
            {store.openingHours}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row items-stretch gap-2">
          <Link
            className="button btn-sm leading-8 btn-primary-full capitalize font-normal! flex-1"
            href={{pathname: '/bar/[barId]', params: {barId: store.id}}}
          >
            {t('home.menu')}
          </Link>
          {store.providerId && (
            <Link
              className="button btn-sm leading-8 btn-primary-full capitalize font-normal! flex-1"
              href={{
                pathname: '/experience/provider-detail/[id]',
                params: {id: store.providerId},
              }}
            >
              {t('home.experiences')}
            </Link>
          )}
        </div>
      </div>
    </li>
  );
}
